class BlogList extends HTMLElement {
  view3Classes;
  
  constructor() {
    super();
    this.init();
  }

  init = () => {
  }

  loadMore = (url) => {
    axios.get(url)
      .then((response) => {
        const doc = Utils.getDocument(response.data);
        const list = doc.querySelector(this.tagName.toLowerCase());
        const loader = doc.querySelector('blog-load');
        var loadUrl = null;
        if(loader != null) {
          loadUrl = loader.dataset.link;
        }
        this.innerHTML += list.innerHTML;
        this.dispatchEvent(new CustomEvent(Utils.E_BLOG_LOADED, { detail: {
          loadUrl: loadUrl,
        } }));
        
        window.history.replaceState(null, null, url);
      })
      .catch((error) => {
        Utils.errorHanlder(error);
      });
  }
}
if (!window.customElements.get("blog-list")) {
  window.customElements.define("blog-list", BlogList);
}

class BlogLoad extends HTMLElement {
  list; counter; total; link; loading; spinner;
  static selectors = {
    spinner: '[data-spinner]',
  }
  static classes = {
    loaded: 'd-none'
  }
  
  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.list = document.querySelector(this.dataset.list);
    this.counter = document.querySelector(this.dataset.counter);
    this.spinner = this.querySelector(BlogLoad.selectors.spinner);
    this.total = parseInt(this.dataset.total);
    this.link = this.dataset.link;
    this.loading = false;

    if(this.list.tagName === 'BLOG-LIST') {
      this.addEventListener('click', (e) => {
        e.preventDefault();
        this.loadMore();
      });

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.loadMore();
          }
        });
      });

      observer.observe(this);
    }

    this.list.addEventListener(Utils.E_BLOG_LOADED, (e) => {
      this.updateLoader(e.detail.loadUrl);
    });
  }

  loadMore = () => {
    if(this.loading) {
      return;
    }
    this.loading = true;
    if(this.spinner)
      this.spinner.classList.remove(BlogLoad.classes.loaded);
    this.list.loadMore(this.link);
  }

  updateLoader = (loadUrl) => {
    const num = this.list.querySelectorAll('article').length;
    this.link = loadUrl;
    if(this.counter != undefined){
      this.counter.innerHTML = num;
    }
    console.log(num, this.total);
    if(num >= this.total) {
      this.remove();
    }
    this.loading = false;
    if(this.spinner)
      this.spinner.classList.add(BlogLoad.classes.loaded);
  }

}
if (!window.customElements.get("blog-load")) {
  window.customElements.define("blog-load", BlogLoad);
}